import React from 'react'

export const georgiaSetupVars = {
  siteId: 'georgia',
  pathPrefix: '/ga',
  menuHeader: "Discover Georgia's Solution for:",
  appUrl: 'https://ga.headed2.com',
  logoImg: '/images/assets/georgia/horizontal/dark.svg',
  headerTitle: `The Georgia CareerExplorer is a system designed for Georgia`
}
